import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';

var useBeforeunload = function useBeforeunload(handler) {
  if (handler === void 0) {
    handler = function handler() {};
  }

  if (process.env.NODE_ENV !== 'production' && typeof handler !== 'function') {
    throw new TypeError("Expected \"handler\" to be a function, not " + typeof handler + ".");
  }

  var handlerRef = useRef(handler);
  useEffect(function () {
    handlerRef.current = handler;
  }, [handler]);
  useEffect(function () {
    var handleBeforeunload = function handleBeforeunload(event) {
      var returnValue;

      if (typeof handlerRef.current === 'function') {
        returnValue = handlerRef.current(event);
      }

      if (event.defaultPrevented) {
        event.returnValue = '';
      }

      if (typeof returnValue === 'string') {
        event.returnValue = returnValue;
        return returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeunload);
    return function () {
      window.removeEventListener('beforeunload', handleBeforeunload);
    };
  }, []);
};

var Beforeunload = function Beforeunload(props) {
  useBeforeunload(props.onBeforeunload);
  return props.children;
};

Beforeunload.defaultProps = {
  children: null
};
Beforeunload.propTypes = {
  children: PropTypes.any,
  onBeforeunload: PropTypes.func.isRequired
};

export { Beforeunload, useBeforeunload };
